import React from 'react';
import * as R from 'ramda';
import { SendUserActivationEmailByPartnerId } from '../../../../../actions/backoffice/partners';
import { useDispatch } from 'react-redux';

export const UsersTableRow = ({ user, etablissements, setSelectedUser }) => {
    const dispatch = useDispatch();
    const etablissementName = R.isNil(etablissements) ? "" : R.isNil(user.etablissementId) ? "" : etablissements.find(e => e.id === user.etablissementId)?.name;
    return (
        <div className="card p-2 mt-1">
            <div className="row gx-2 gy-1 align-items-center">
                <div className="col-12 col-md">
                    <div className="row gx-2 gy-1 align-items-center">
                        <div className="col order-first order-md-0">
                            <div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-truncate">{user.firstName} {user.lastName}</div>
                        </div>
                        <div className="col-1 col-md">
                            <div className="h5 ls-1 my-auto text-truncate text-muted">{user.phoneNumber}</div>
                        </div>
                        <div className="col-12 col-md">
                            <div className="h5 ls-1 my-auto text-truncate">{R.isNil(user.etablissementId) || user.etablissementId === "00000000-0000-0000-0000-000000000000" ? "Administrateur" : "Etablissement"}</div>
                        </div>
                        <div className="col-12 col-md">
                            <div className="h5 ls-1 my-auto text-truncate">{etablissementName}</div>
                        </div>
                        <div className="col-auto col-md col-xl-1">
                            <div className="h5 ls-1 my-auto container-press ml-auto">{user.daysOfTraining > 0 ? "Oui" : "Non"}</div>
                        </div>
                        <div className="col col-lg-2 col-xl-1">
                            <div className="h5 ls-1 my-auto container-press ml-auto">{user.isEnabled ? "Actif" : "Désactivé"}</div>
                        </div>
                    </div>
                </div>
                <div className="col-12 d-md-none">
                    <hr className="my-0" />
                </div>
                <div className="col-12 col-md-3 col-lg-auto ml-auto">
                    <div className="w-md-min"></div>
                    <div className="flex-row justify-content-md-end">
                        <button type="button" className="btn btn-icon btn-stage-danger shadow-none p-1 rounded-sm mr-auto mr-md-0" data-toggle="modal" data-target="#DeletePartnerUser" onClick={(e) => setSelectedUser(user)}>
                            <i className="eva eva-trash-2-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Supprimer le utilisateur" data-template='<div class="tooltip tooltip-white-danger" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
                        </button>
                        <button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#AddPartnerUser" onClick={(e) => setSelectedUser(user)}>
                            <i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Modifier le utilisateur" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
                        </button>
                        <button type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2"
                            onClick={(e) => dispatch(SendUserActivationEmailByPartnerId(user.id, user.partnerId, R.isNil(user.etablissementId) ? "PARTNER" : "ETABLISSEMENT"))}
                            data-toggle="tooltip" title="Renvoyer invitation" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'>
                            <i className="eva eva-email-outline align-middle h4 lh-1 m-auto"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

};